import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TerminalsService} from "../../../shared/services/terminals.service";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {validIban} from "../../../shared/validator/iban-validator";
import {ArrayValidators} from "../../../shared/validator/array-validators";

@Component({
  selector: 'app-add-terminal-dialog',
  templateUrl: './add-terminal-dialog.component.html',
  styleUrls: ['./add-terminal-dialog.component.scss']
})
export class AddTerminalDialogComponent implements OnInit {
  processingRequest = false;
  insuranceCompanyControl: FormControl;
  policyNumberControl: FormControl;
  accountNumberControl: FormControl;
  sumControl: FormControl;
  addPolicyForm: FormGroup;
  partnerControl: FormControl;
  formErrors: any = {};
  formArray: FormGroup[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddTerminalDialogComponent>,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private terminalsService: TerminalsService,
    private formHelper: FormHelperService,
  ) {
    this.addPolicyForm = this.fb.group({
      terminals: fb.array(this.formArray, [ArrayValidators.minLength(1)]),
      partner: this.partnerControl = this.fb.control('', [Validators.required]),
      validPolisNumber: this.fb.control(false, [Validators.required]),
    });
    this.addTerminals();
  }

  ngOnInit(): void {
  }


  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  addTerminals(): void {
    this.formArray.push(new FormGroup({
      insuranceCompany: new FormControl( '', [Validators.required]),
      policyNumber: new FormControl( '', [Validators.required]),
      accountNumber: new FormControl('', [Validators.required , validIban()]),
      sum: new FormControl('', [Validators.required]),
    }));
    this.updateTerminalsFormArray();
  }

  updateTerminalsFormArray(): void {
    this.addPolicyForm.setControl('terminals', new FormArray(this.formArray, [ArrayValidators.minLength(1)]));
  }

  removeRepresentation(index: number): void {
    this.formArray.splice(index, 1);
    this.updateTerminalsFormArray();
  }

  sendForm(close?: boolean): void {
    if ( !this.addPolicyForm.valid)
    {
      this.addPolicyForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;

    this.formErrors = {};

    this.terminalsService.send(this.addPolicyForm.value)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano polisę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (close){
          this.addPolicyForm.reset();
          this.addPolicyForm.get('validPolisNumber').setValue(false);
        } else {
          this.dialogRef.close();
        }
      }, (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.addPolicyForm.get('validPolisNumber').setValue(true);
          this.snack.open(error.error.error.text, error.status.toString(), {duration: 4000});
        } else {
          this.snack.open('Podczas dodawania polisy wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
        this.processingRequest = false;
      })
    ;
  }

}
